import { render, staticRenderFns } from "./DistributorList.vue?vue&type=template&id=d7e6790e"
import script from "./DistributorList.vue?vue&type=script&lang=js"
export * from "./DistributorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports